import { useCallback, useRef, useState } from 'react';

export const useSyncReducer = <S, A>(
  reducer: (state: S, action: A) => S,
  initial: S
) => {
  const ref = useRef(initial);
  const [state, setState] = useState(initial);
  const dispatch = useCallback(
    (action: A) => {
      const before = ref.current;
      ref.current = reducer(before, action);
      setState(ref.current);
      return before;
    },
    [reducer]
  );
  return [state, dispatch, ref] as const;
};
